import { EntityService } from '@/services/EntityService';
import { ErrorWrapper, ResponseWrapper } from '@/services/util';

export class TilesService extends EntityService {
  static get entity() {
    return 'applications';
  }

  static async getTilesGroupsById(id) {
    try {
      const response = await this.request({ auth: true }).get(
        `${this.entity}/${id}/tiles-groups`
      );
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }
}
